import { AsyncPipe, NgClass } from '@angular/common';
import { Component, input, signal } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { SrcSecurePipePipe } from '@core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  imports: [MatProgressSpinner, NgxSkeletonLoaderModule, SrcSecurePipePipe, AsyncPipe, NgClass],
  selector: 'app-img-loader',
  standalone: true,
  templateUrl: './img-loader.component.html',
})
export class ImgLoaderComponent {
  loader = input<'skeleton' | 'spinner'>('spinner');
  imgSrc = input.required<string>();
  imgCSSClass = input('');
  errorSrc = input('');
  altText = input('Image text placeholder');
  loaderHeight = input(150);

  protected loading = signal(true);

  protected onLoad() {
    this.loading.set(false);
  }
}
